import { Component, OnInit } from '@angular/core';
import { WinService } from 'src/app/services/win.service';

@Component({
  selector: 'app-free-shipping-banner-top',
  templateUrl: './free-shipping-banner-top.component.html',
  styleUrls: ['./free-shipping-banner-top.component.scss']
})
export class FreeShippingBannerTopComponent implements OnInit {

	constructor(
		public winService: WinService
	) { }

	ngOnInit(): void {
	}

}
